import Input from './Input';
import { useState } from 'react';
import { Control } from 'react-hook-form';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';

interface Props extends Omit<TextFieldProps, 'name' | 'helperText'> {
  name: string;
  control: Control<any>;
  helperText?: string | null;
  rules?: any;
}

export default function PasswordInput({ name, control, rules, ...rest }: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const toggleVisibility = () => setShowPassword((prev) => !prev);
  return (
    <Input
      name={name}
      control={control}
      rules={rules}
      type={showPassword ? 'text' : 'password'}
      {...rest}
      InputProps={{
        ...(rest.InputProps || {}),
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton onClick={toggleVisibility} edge='end'>
              {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
}
